import s from "./ReportLayoutButton.module.scss";
import * as icons from "./assets/index";
import * as widgets from "../../../extractedComponents/index";
import { DraggableItem } from "src/components/DraggableItem/DraggableItem";

type IconType = keyof typeof icons;
type IdType = keyof typeof widgets;
interface IProps {
  icon: IconType;
  id: IdType;
  text: string;
}

export const ReportLayoutButton = ({ icon, id, text }: IProps) => {
  const Icon = icons[icon];

  return (
    <DraggableItem id={id} className={s.container}>
      <div className={s.icon}>
        <Icon />
      </div>
      <span>{text}</span>
    </DraggableItem>
  );
};
